import { memo, useMemo } from "react";

import Text from "./Text";
import EditableSelectCell from "./EditableSelectCell";

const COLUMNS = [
    {key: 'nomina', label: 'Nómina', width: {flex: '.5 1 90px', minWidth: '80px'}},
    {key: 'nombre', label: 'Nombre', width: {flex: '3 1 320px', minWidth: '200px'}},
    {key: 'turno', label: 'Turno', width: {flex: '1 1 150px', minWidth: '130px'}},
    {key: 'horario', label: 'Horario', width: {flex: '1 1 130px', minWidth: '110px'}},
    {key: 'dias', label: 'Días laborables', width: {flex: '1 1 160px', minWidth: '140px'}},
    {key: 'maquina', label: 'Máquina', width: {flex: '2 1 220px', minWidth: '170px'}},
    {key: 'puesto', label: 'Puesto', width: {flex: '1 1 150px', minWidth: '130px'}},
];
const EDITABLE = {turno: 'Sin turno', maquina: 'Sin máquina', puesto: 'Sin puesto'};

const getStyles = (theme) => {
    const isDark = theme.White !== "#FFFFFF";
    return {
        row: {
            display: 'flex', width: '100%', height: '38px', alignItems: 'center', boxSizing: 'border-box',
            border: `0.5px solid ${theme.Ey}`, borderRadius: '4px', backgroundColor: isDark ? theme.Ey : theme.Ed
        },
        col: (width) => ({
            ...width, display: 'flex', alignItems: 'center', boxSizing: 'border-box', padding: '0 16px'
        }),
        truncate: {
            whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%'
        }
    }
}

const RoleRow = memo(({row, options, theme, onChange}) => {
    const styles = getStyles(theme);
    //Rows that block saving in orange (takes priority), pending changes in magenta
    const marker = row.incompleto ? theme.Orange : row.editado ? theme.Magenta : 'transparent';

    return (
        <div style={{...styles.row, borderLeft: `3px solid ${marker}`}}>
            {COLUMNS.map(col => (
                <div key={col.key} style={styles.col(col.width)} title={EDITABLE[col.key] ? undefined : (row[col.key] ?? '')}>
                    {EDITABLE[col.key] ? (
                        <EditableSelectCell value={row[col.key] ?? ''} options={options[col.key]} placeholder={EDITABLE[col.key]} theme={theme} error={row.errores[col.key]}
                            onChange={(value) => onChange(row.nomina, col.key, value)}/>
                    ) : (
                        <Text size={15} color={col.key === 'horario' || col.key === 'dias' ? theme.SEVENB : theme.ONED} style={styles.truncate}>
                            {row[col.key] || '-'}
                        </Text>
                    )}
                </div>
            ))}
        </div>
    )
});

const WeeklyRolesTable = ({rows, opciones, theme, requestSort, getIcon, onChange}) => {
    const styles = getStyles(theme);

    const options = useMemo(() => ({
        turno: [{value: '', label: 'Sin turno'}, ...opciones.turnos.map(t => ({value: t.turno, label: `${t.turno} · ${t.horario}`}))],
        maquina: opciones.maquinas.map(m => ({value: m, label: m})),
        puesto: [{value: '', label: 'Sin puesto'}, ...opciones.puestos.map(p => ({value: p, label: p}))],
    }), [opciones]);

    return (
        <div style={{width: '100%', minWidth: 0, height: '500px', overflowY: 'auto', overflowX: 'auto'}}>
            <div style={{minWidth: 'min-content', maxWidth: '100%'}}>
                <div style={{position: 'sticky', top: 0, zIndex: 1, backgroundColor: styles.row.backgroundColor}}>
                    <div style={styles.row}>
                        {COLUMNS.map(col => (
                            <div key={col.key} onClick={() => requestSort(col.key)} style={{...styles.col(col.width), height: '36px', cursor: 'pointer', userSelect: 'none'}}>
                                <Text size={15} weight="medium" color={theme.ONED}>{col.label}</Text>
                                <Text size={12} style={{marginLeft: '4px'}}>{getIcon(col.key)}</Text>
                            </div>
                        ))}
                    </div>
                </div>
                {rows.map(row => (
                    <RoleRow key={row.nomina} row={row} options={options} theme={theme} onChange={onChange}/>
                ))}
            </div>
        </div>
    )
}

export default WeeklyRolesTable;